// extracted by mini-css-extract-plugin
module.exports = {"component":"MatchList--component","entry":"MatchList--entry","unsaved":"MatchList--unsaved","scrollTo":"MatchList--scrollTo"};